import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

// Importar Rutas fuera del admin Nav Rutas acá
import loginRoutes from "@/views/login/routes";
import adminRoutes from "@/views/admin-page/routes";
import errorRoutes from "@/views/errors/routes";

// Importar rutas de Modulos en admin nav acá
import mainRoutes from "@/views/main/routes";
import FlyRoutes from "@/views/flights/routes";
import EmptyLegsRoutes from "@/views/empty-legs/routes";
import RideryFlyUsers from "@/views/ridery-fly-users/routes";
import OperatorsRoutes from "@/views/operators-request/routes";
import AirplanesRoutes from "@/views/airplanes/routes";
import FlightRoutesRoutes from "@/views/flight-routes/routes";
import AirportsRoutes from "@/views/airports/routes";

const routes = [
  // Rutas varias
  ...loginRoutes,
  ...adminRoutes,
  // Módulos
  ...mainRoutes,
  ...FlyRoutes,
  ...EmptyLegsRoutes,
  ...RideryFlyUsers,
  ...OperatorsRoutes,
  ...AirplanesRoutes,
  ...FlightRoutesRoutes,
  ...AirportsRoutes,
  // Errores
  ...errorRoutes,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, _from, next) => {
  // Get user information from the Vuex store
  const user = store.state.auth.user;

  // Extract permissions and adminType from user details
  const { isLoggedIn } = user; //sub admin no permission, per default

  // Check if the route requires authentication
  const requiresAuth = to.matched.some((route) => route.meta.requiresAuth);
  // Authentication logic
  if (requiresAuth && !isLoggedIn) {
    // Show error notification if the user is not logged in
      Vue.prototype.$dialog.notify.error("No se encuentra logueado");

    // Redirect to the login page with a redirect query only if not already on the login page
    if (to.name !== "login") {
      return next({ name: "login", query: { redirect: to.fullPath } });
    }
  }

  // Continue with the navigation
  next();
});

export default router;
